import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface BreadcrumbProps {
  currentPage: string;
  backLabel?: string;
}

export const Breadcrumb: React.FC<BreadcrumbProps> = ({
  currentPage,
  backLabel,
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="flex items-center gap-2 text-sm">
      <button
        onClick={() => navigate(-1)}
        className="text-blue-600 hover:text-blue-800"
      >
        {backLabel || t('common.back')}
      </button>
      <span className="text-gray-400">/</span>
      <span className="text-gray-700">{currentPage}</span>
    </div>
  );
};
